module.exports = __webpack_public_path__ + "static/media/defaultbanner.4ef8954d.png";